<template>
	<div class="ReDistrictPicker">
		
		<div >
			<!-- <div class="d-flex iframe-button pt-1"><base-button @click="hideDistricts()" type="danger" class="" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button></div> -->
			<div class="inline-flex mb-2 ">
				<base-button @click="loadDistricts()" v-if="switchBtn==false || ApiData.length==0" type="primary" class="mt-0 w-100" simple>Выбор районов</base-button>
				<base-button @click="hideDistricts()" v-if="switchBtn==true" type="primary" class="mt-0 w-100" simple >{{ btnText }}</base-button>

			</div>

			<div v-if="bIsShown">
				<tabs type="primary" 
					:activeTab="currentTab"
					@change="OnTabChange"
					tabContentClasses="tab-opt"
					inline
					round	
					class="card card-plain mb-0 ">
					<tab-pane :id="'78'" label="СПб">
						<template  v-if="currentTab == '78'">
							<template  v-if="ApiData">
								
								<div style="display: flex;">
									<!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll_spb" @change="handleCheckAllChange_spb" class="mb-3">Выбрать всё</el-checkbox>
									<el-checkbox-group v-model="checkedDistricts_spb" @change="handleCheckedCitiesChange">
										<el-checkbox v-for="(distr, distr_id) in ApiData" :label="distr" :key="distr_id">{{ distr.cellName }}</el-checkbox>
									</el-checkbox-group> -->

									
										<div class="checkbox-radios-col">
											<base-radio v-for="(el_opt, el_index) in ApiData" :key="el_opt.id+'_'+el_index" :name="el_opt.id" 
											v-model="bufferValue" :value="el_opt" inline>{{el_opt.cellName}}</base-radio>
										</div>
									
								</div>
							</template>
						</template>
					</tab-pane>

					<tab-pane :id="'47'" label="ЛО">
						<template  v-if="currentTab == '47'">
							<template  v-if="ApiData">
								<!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll_lo" @change="handleCheckAllChange_lo" class="mb-3">Выбрать всё</el-checkbox>
								<el-checkbox-group v-model="checkedDistricts_lo" @change="handleCheckedCitiesChange">
									<el-checkbox v-for="(distr, distr_id) in ApiData" :label="distr" :key="distr_id">{{ distr.cellName }}</el-checkbox>
								</el-checkbox-group> -->
								<div class="checkbox-radios-col">
									<base-radio v-for="(el_opt, el_index) in ApiData" :key="el_opt.id+'_'+el_index" :name="el_opt.id" 
									v-model="bufferValue" inline>{{el_opt.cellName}}</base-radio>
								</div>
							</template>							
						</template>	
					</tab-pane>
					<tab-pane :id="'10'" label="Карелия">
						<template  v-if="currentTab == '10'">
							<template  v-if="ApiData">
								<!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll_ka" @change="handleCheckAllChange_ka" class="mb-3">Выбрать всё</el-checkbox>
								<el-checkbox-group v-model="checkedDistricts_ka" @change="handleCheckedCitiesChange">
									<el-checkbox v-for="(distr, distr_id) in ApiData" :label="distr" :key="distr_id">{{ distr.cellName }}</el-checkbox>
								</el-checkbox-group> -->
								<div class="checkbox-radios-col">
									<base-radio v-for="(el_opt, el_index) in ApiData" :key="el_opt.id+'_'+el_index" :name="el_opt.id" 
									v-model="bufferValue" inline>{{el_opt.cellName}}</base-radio>
								</div>
							</template>							
						</template>	
					</tab-pane>

				</tabs>
			</div>
			<!-- <base-input type="hidden" v-model="bufferValue"></base-input> -->
		</div>
	<!-- <pre>ApiData.length	{{ ApiData.length }} </pre> -->	<!-- <pre>	{{ ApiData }} </pre> -->
		
		
	</div>
</template>

<script>
	import { Select, Option, CheckboxGroup, Checkbox, RadioGroup, Radio  } from 'element-ui';
	import { TabPane, Tabs } from 'src/components';
	import { BaseRadio } from 'src/components/index';

	export default {
		name: 'ReDistrictPicker',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
			[Radio.name]: Radio, 
			[RadioGroup.name]: RadioGroup,
			TabPane,
			Tabs,
			BaseRadio,
		},
		props: {
			value: [Number, String, ],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			// value: {
			// 	type: Object,
			// 	default() {	return {'distr_id':''}; }
			// },
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				bIsShown:false,
				switchBtn:false,
				btnText: 'Выбор районов', 
				currentTab:'78',
				// distrTab: '78',
				ApiData:[],
				// checkedDistricts_spb: [],
				// checkedDistricts_lo:[],
				// checkedDistricts_ka:[],
				// checkAll_spb: false,
				// checkAll_lo: false,
				// checkAll_ka: false,
				// isIndeterminate: false,
				bufferValue: '',
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
				// console.log(this.value,'value');
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
				this.$emit('bufferValueDistr', this.bufferValue);
				// this.$emit('checked', JSON.stringify(this.bufferValue));
				// console.log(this.bufferValue,'bufferValue');
			},
			
		},
		computed: {
			
		},
		methods: {
			
			loadDistricts(){
				this.bIsShown = true;
				this.switchBtn = true;
				// console.log('this.bIsShown', this.bIsShown);
				// if(this.bIsShown == true){
				// 	this.btnText = 'Скрыть районы';
				// } else {this.btnText = 'Выбор районов';}
				this.getApiData('78');
			},
			hideDistricts(){
				this.bIsShown = !this.bIsShown;
				// console.log('this.bIsShown', this.bIsShown);
				if(this.bIsShown == true){
					this.btnText = 'Скрыть районы';
				} else {this.btnText = 'Выбор районов';}
				
			},
			OnTabChange(strTabId){
				if(this.currentTab == strTabId) return true;
				this.currentTab = strTabId;
				// this.$emit('input', strTabId);
				// this.$emit('change', strTabId);
				this.getApiData(strTabId);
				this.bufferValue = '';
				if(this.value!='')this.bufferValue = this.value;
				// if(strTabId=='78'){
				// 	this.checkAll_lo=false;
				// 	this.checkAll_ka=false;
				// 	this.checkedDistricts_lo=[];
				// 	this.checkedDistricts_ka=[];
				// 	this.isIndeterminate = false;
				// } else if (strTabId=='47'){
				// 	this.checkAll_spb=false;
				// 	this.checkAll_ka=false;
				// 	this.checkedDistricts_spb=[];
				// 	this.checkedDistricts_ka=[];
				// 	this.isIndeterminate = false;
				// } else if (strTabId=='10'){
				// 	this.checkAll_spb=false;
				// 	this.checkAll_lo=false;
				// 	this.checkedDistricts_spb=[];
				// 	this.checkedDistricts_lo=[];
				// 	this.isIndeterminate = false;
				// }
				
			},
			getApiData(region){
				// let filter = {list:true};

				this.$GVO.ApiCall('cat_districts.GET',{flt:{/*...filter, */region:region, act:'1'}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
							if(this.value!='')this.bufferValue = this.value;
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
				
			},
			// handleCheckAllChange_spb(val) {
			// 	this.checkedDistricts_spb = val ? this.ApiData : [];
				
			// 	// this.filterTags.push(tag);
			// 	this.isIndeterminate = false;
			// },
			// handleCheckAllChange_lo(val) {
			// 	this.checkedDistricts_lo = val ? this.ApiData : [];
			// 	// this.bufferValue = this.checkedDistricts_lo.id
			// 	this.isIndeterminate = false;
			// },
			// handleCheckAllChange_ka(val) {
			// 	this.checkedDistricts_ka = val ? this.ApiData : [];
			// 	// this.bufferValue = this.checkedDistricts_ka.id
			// 	//console.log(this.checkedDistrictsLo,'checkedDistrictsLo');
			// 	this.isIndeterminate = false;
			// },
			// handleCheckedCitiesChange(value) {
			// 	// console.log(value.length);
			// 	let checkedCount = value.length;
			// 	this.checkAll_spb = checkedCount === this.ApiData.length;
			// 	this.checkAll_lo = checkedCount === this.ApiData.length;
			// 	this.checkAll_ka = checkedCount === this.ApiData.length;
			// 	this.isIndeterminate = checkedCount > 0 && checkedCount < this.ApiData.length;
			// },
			
	
		},
		mounted() {
			
			
		}
	}
</script>
<style scoped>

.ReDistrictPicker >>> .nav-pills .nav-item .nav-link {padding: 0px 20px; min-width: 74px;} 
.ReDistrictPicker >>> .tab-content {padding-top: 0px;}

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}
.ReDistrictPicker .el-checkbox-group, .ReDistrictPicker .el-radio-group {
    display: flex;
    flex-direction: column;
	width: 49%;
}
.ReDistrictPicker .checkbox-radios-col {
	display: flex;
    flex-direction: column;
}
.white-content .card:not(.card-white) >>> label {
		color: #1d253b!important;
	}
/*===media===============================*/
@media (max-width: 768px) {
	/* .flat .row {width: 100%; margin-left: 0px;} */
}

</style>
